import React from 'react';
import { Box } from '@mui/material';
import Logo from '../resources/images/logos/LogoColor.png';
import Link from '../resources/images/stock/Link.png';

const PublicLayout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#FFFFFF'
      }}>
      {/* Background Image as img element to always show fully */}
      <Box
        component="img"
        src={Link}
        alt="Background"
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          height: '100vh', // full viewport height
          width: 'auto', // maintain aspect ratio
          objectFit: 'contain',
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: { xs: 'center', md: 'flex-start' },
          px: { xs: 2, md: 8 },
          pt: { xs: 6, md: 6 },
          pb: 6,
          zIndex: 1,
          position: 'relative',
          width: '100%'
        }}>
        {/* Logo */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' },
            mb: 2
          }}>
          <Box component="img" src={Logo} alt="Fairtree logo" width="400px" />
        </Box>

        {/* Children content box */}
        <Box
          sx={{
            width: { xs: '100%', sm: '80%', md: '400px' },
            backgroundColor: 'white',
            p: { xs: 3, md: 0 },
            boxShadow: { xs: '0px 4px 10px rgba(0, 0, 0, 0.05)', md: 'none' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' }
          }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default PublicLayout;
